import { toast } from 'react-toastify';
import copy from 'copy-to-clipboard';

export const copyToClipboard = async (value: any, successText?: string, errorText?: string) => {
    try {
        if (typeof value !== 'string') {
            throw '';
        }
        if (!!navigator.share) {
            await navigator
                .share({ url: value, title: '', text: '' })
                .then((r) => r)
                .catch((error) => {
                    throw { message: 'share function' };
                });
        } else {
            copy(value);
            // await navigator.clipboard.writeText(value);
            toast.success(!!successText ? successText : '클립보드에 복사되었습니다!', {
                toastId: 'copy-success',
                position: 'top-center',
                autoClose: 800,
                hideProgressBar: true,
            });
        }
    } catch (error: any) {
        console.error('클립보드 복사 실패:', error);
        console.log(JSON.stringify(error));
        if (!!((error?.message || '') === 'share function')) {
        } else {
            toast.error(!!errorText ? errorText : '클립보드 복사에 실패했습니다.', {
                toastId: 'copy-fail',
                position: 'top-center',
            });
        }
    }
};
